import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  cardContainer: {
    padding: "20px",
    marginBottom: theme.spacing(2),
  },
  topContainer: {
    marginBottom: theme.spacing(3),
    display: "flex",
    alignItems: "flex-start",
    [theme.breakpoints.down("xs")]: {
      flexWrap: "wrap",
    },
  },
  leftContainer: {
    order: 1,
    width: "60%",
    [theme.breakpoints.down("xs")]: {
      width: "80%",
      flexWrap: "wrap",
    },
  },
  textFieldInput: {
    "& .MuiInputBase-root-997": {
      padding: "0px",
    },
  },

  rightContainer: {
    order: 2,
    width: "40%",
    [theme.breakpoints.down("xs")]: {
      order: 3,
      width: "100%",
      justifyContent: "flex-start",
      marginTop: theme.spacing(1),
    },
  },
  deleteContainer: {
    order: 3,
    [theme.breakpoints.down("xs")]: {
      width: "20%",
      order: 2,
      display: "flex",
      alignItems: "center",
    },
  },
  sentText: {
    color: "#C9BE3B",
    fontSize: "16px",
    textAlign: "left",
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
      marginLeft: "48px",
    },
  },
  acceptedText: {
    color: theme.palette.success.main,
    textAlign: "left",

    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
      marginLeft: "45px",
    },
  },
  rejectedText: {
    color: theme.palette.error.main,
    textAlign: "left",
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
      marginLeft: "45px",
    },
  },

  deleteIcon: {
    color: theme.palette.error.main,
    fontSize: "28px",

    [theme.breakpoints.down("xs")]: {
      fontSize: "18px",
      justifyContent: "flex-end",
    },
  },
  dateText: {
    marginLeft: theme.spacing(1),
    textAlign: "left",
    fontSize: "16px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "13px",
    },
  },
  addItemButton: {
    [theme.breakpoints.down("xs")]: {
      fontSize: "15px",
      marginTop: "15px",
      marginBottom: "15px",
    },
  },
  addIcon: {
    fontSize: "18px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "15px",
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-start",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "left",
    },
  },
  mobileLabels: {
    marginTop: "5px",
    fontSize: "12px",
    color: "#9A9A9A",
    textAlign: "center",
  },

  bottomContainer: {},
}))

export default styles
